{
    "colorBook": {
        "pages": [
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory1.b0af7a35.jpg",
                "svg": "/assets/svgs/EagleBook01.c7ee2d11.svg",
                "lang": {
                    "en": {
                        "text": "Once upon a time there were two eagles who built their nest upon the highest mountain top, far above the valley.\nThey were happy, loved the freedom of the skies and took long flights over mighty mountains and deep valleys. Until one day ...",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Es waren einmal zwei Adler, die bauten Ihr Nest auf die höchste Bergspitze weit über dem Tal. Sie waren glücklich, liebten die Freiheit des Himmels und machten weite Flüge über mächtige Berge und tiefe Täler, bis eines Tages...",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Il était une fois deux aigles, qui construisirent leur nid au sommet de la plus haute montagne, bien au-dessus de la vallée.\nIls étaient heureux, ils aimaient la liberté des cieux et volaient longuement au-dessus d’immenses montagnes et de profondes vallées, jusqu’au jour où...",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Pewnego razu były dwa orły, które wybudowały gniazdo na szczycie najwyższej góry, daleko poza doliną.\nOrły były bardzo szczęśliwe. Uwielbiały wolność, jaką miały w powietrzu, podejmowały długie loty nad potężnymi górami i głębokimi dolinami.\nAż do pewnego dnia…",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "C'erano una volta due aquile che costruirono il loro nido sopra la cima più alta della montagna , al di sopra della valle.\nErano felici, amavano la libertà dei cieli e volavano sopra montagne imponenti e profondi valli, Finché un giorno…",
                        "audio": ""
                    },
                    "ro": {
                        "text": "A fost odată doi vulturi care şi-au construit cuibul pe cel mai înalt creştet de munte cu mult deasupra văii.\nEi erau fericiţi, iubeau libertatea cerului, şi zburau deasupra munţilor înalţi si văilor adânci. Până când într-o zi…",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory2.9b0b950b.jpg",
                "svg": "/assets/svgs/EagleBook02.3d6018b9.svg",
                "lang": {
                    "en": {
                        "text": "There was a farmer who wanted his hen to lay eggs. He needed fifteen eggs altogether, but he only had fourteen.\nThen he remembered the eagle who built a nest on the top of the mountain. Quickly he climbed up the cliff. He robbed one egg from the eagle's nest and put it under his hen.\nNow he had fifteen eggs, just the right amount!",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Ein Bauer wollte seine Henne zum Brüten setzen. Dazu brauchte er fünfzehn Eier, doch er hatte nur vierzehn.\nDa erinnerte er sich an die Adler, die Ihr Nest hoch oben auf dem Berg gebaut hatten. Schnell stieg er den steilen Felsen hinauf, raubte dem Adler ein Ei und legte es unter die Henne.\nNun hatte er fünfzehn Eier, genau die richtige Zahl.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Il y avait un fermier qui désirait que ses poules pondent des oeufs. Il avait besoin de quinze oeufs en tout, mais n’en avait que quatorze.\nIl se rappela alors de l’aigle qui avait fait son nid au sommet de la montagne. Rapidement, il escalada le rocher, vola un oeuf à l’aigle et le mit à couver sous sa poule.\nIl en avait maintenant quinze, exactement le nombre qu’il lui fallait!",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Był również rolnik, który chciał, aby jego kura złożyła jajka. Potrzebował razem piętnaście jajek, a miał tylko czternaście.\nWtedy przypomniał sobie orła, który wybudował gniazdo na szczycie góry. Szybko wspiął się po stromym zboczu, ukradł jedno jajko z gniazda orła i podłożył go pod swoją kurę.\nTeraz miał piętnaście jajek, dokładnie odpowiednią ilość.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "C'era un agricoltore che voleva che le sue galline deponessero uova.\nAveva bisogno complessivamente di quindici uova, ma ne aveva solamente quattordici.\nAllora, si ricordò dell'aquila che aveva costruito un nido in cima alla montagna. Si arrampicò velocemente per la rupe. Rubò un uovo dal nido dell'aquila e lo mise sotto la sua gallina.\nOra, aveva quindici uova, proprio la giusta quantità!",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Era un fermier care a vrut ca găina să depună ouă.\nEl avea nevoie de cincisprezece ouă pentru un singur cuib, totuşi el avea numai paisprezece.\n Atunci îşi aminteşte de acel vultur care şi-a construit cuibul pe vârful muntelui.Repede el s-a căţărat pe stâncă şi a luat un ou de vultur şi l-a pus sub găină.\nAcum el avea cincisprezece, chiar suma corectă!",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory3.245debd3.jpg",
                "svg": "/assets/svgs/EagleBook03.fd92f70a.svg",
                "lang": {
                    "en": {
                        "text": "When the breeding-time was over, fourteen sweet little yellow chicks ran around, all except one.\nHe was grey and half naked. His eyes were too big, his bill was too long and the feathers were tousled. He was the funniest looking thing the chickens had ever seen, just an ugly duckling.\nThe chicks could stretch theirlittle wings and flop around, but not the little eagle. He just sat aside and watched them sadly.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Als die Brutzeit vorüber war, schlüpften aus den Eiern fünfzehn niedliche kleine gelbe Küken – bis auf das Eine. Es war grau und viel größer. Seine Augen waren zu groß, der Schnabel zu lang, die Federn zerzaust – kurz, es war das sonderbarste kleine Ding das die Hühner je gesehen hatten – ein häßlicher kleiner Kerl.\nDie Küken konnten herumspringen und mit ihren kleinen Flügeln schlagen, doch das konnte der kleine Adler nicht. Er saß nur abseits und schaute traurig zu.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Quand la couvaison fut terminée, quatorze jolis petits poussins jaunes couraient de toute part, tous, à l’exception d’un.\nIl était gris et à moitié nu. Ses yeux étaient trop grands, son bec trop long et ses plumes ébouriffées. Il était la créature la plus étrange que les poulets aient jamais vue, un vilain petit canard.\nLes poussins pouvaient étendre leurs petites ailes et voltiger de-ci de-là, mais pas le petit aigle. Il restait assis sur le côté et les regardait tristement.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Kiedy czas wysiadywania się skończył, czternaście słodkich, małych, żółtych kurczaków biegało wokoło. Wszystkie biegały, z wyjątkiem jednego.\nTen jeden był szary i na pół goły. Jego oczy były za duże, jego dziób za długi, a pióra w nieładzie. Był najzabawniej wyglądającym stworzeniem, jakie kurczęta kiedykolwiek widziały; po prostu brzydkie kaczątko.\nKurczęta potrafiły rozłożyć swoje małe skrzydełka i trzepotać nimi, lecz mały orzeł tego nie potrafił. Siedział tylko na uboczu i smutno im się przyglądał.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "Quando il tempo di cova terminò, quattordici piccoli e dolci pulcini gialli correvano dappertutto, tutti tranne uno.\nEsso era grigio e mezzo nudo. I suoi occhi erano troppo grandi, il suo becco troppo lungo e le piume erano arruffate. Aveva l'aspetto più strano che i polli avessero mai visto, davvero un brutto anatroccolo.\nI pulcini potevano allungare le loro piccole ali e svolazzare dappertutto, ma non il piccolo acquilotto. Lui stava in disparte e li guardava tristemente.",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Când timpul clocirii s-a terminat, paisprezece puişori drăguţi, galbeni, fugeau peste tot, toţi inafară de unul.\nEl era gri şi pe jumătate gol. Ochii lui erau prea mari, ciocul lui era prea mare şi penele lui erau ciufulite. El era lucrul cu arătarea cea mai ciudată pe care a văzut-o puii vreodată, doar o răţuşcă urâtă.\nPuişorii îşi puteau întinde aripioarele şi să bată din ele, dar nu şi vulturaşul pentru că asta era el. El şedea la o parte şi doar îi privea cu tristeţe.",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory4.525b1566.jpg",
                "svg": "/assets/svgs/EagleBook04.c72d4fde.svg",
                "lang": {
                    "en": {
                        "text": "The old hen always scratched in the barn and on the manure piles. Every time she found a little worm, she clucked aloud, 'cluck cluck cluck cluck' and all of the little chickens came running to her, because they understood all of her cluck clucks.\nOnly the little eagle didn't understand any of these cluck clucks. The little chickens picked on that odd little fellow, but he couldn't understand what they were chirping about, because he spoke a different language.\nThe chickens scratched in the manure piles, cluck cluck cluck. They loved the worms and bugs. So the little eagle scratched with them, because he didn't know anything else, but what he saw the chickens do. Yet, there was something different about him, he didn't like it.\nHe just couldn't understand why everything was going like that, and why he had to be the ugly bird and so very different from the rest of them.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Die alte Henne kratzte auf dem Hof oder scharrte auf dem Misthaufen und jedesmal wenn sie einen Wurm gefunden hatte, gackerte sie laut: “Gluck, gluck, gluck, gluck“ , ... und die kleinen Küken rannten zu ihr, denn sie verstanden jedes von ihren “gluck glucks“.\nNur der kleine Adlerjunge verstand nicht eines von diesen “gluck glucks“. Die kleinen Küken pickten auf dem komischen Burschen herum, aber er verstand nicht ein Wort, was sie zu ihm sagten, denn er sprach eine andere Sprache.\nDie Kücken scharrten auf dem Misthaufen, “gluck, gluck, gluck“ - sie liebten die Würmer und das Zeug und der kleine Adler kratzte mit ihnen. Er wußte ja nichts anderes als was er bei den Hühnern sah. Aber da war ein Unterschied, - er liebte es nicht.\nEr konnte einfach nicht verstehen warum alles so war und er der häßliche Vogel sein mußte und so anders wie all die andern.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "La vieille poule grattait dans la grange et sur le tas de fumier. Chaque fois qu’elle trouvait un petit ver, elle gloussait très fort “cot, cot, cot, cot……” et tous les petits poussins accouraient près d’elle, car ils comprenaient chacun de ses gloussements.\nSeul le petit aigle n’y comprenait rien. Les petits poulets cherchaient toujours querelle à cet étrange petit gars, mais lui ne pouvait comprendre ce qu’ils pépiaient, car il parlait une autre langue.\nLes poulets grattaient sur les tas de fumier, cot, cot, cot. Ils aimaient les vers et les punaises. Ainsi le petit aigle grattait avec eux, car il ne connaissait rien d’autre que ce qu’il voyait les autres faire. Toutefois, il y avait quelque chose de différent à son sujet et cela ne lui plaisait pas.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Stara kura zawsze grzebała w stodole i na kupie gnoju. Za każdym razem, kiedy znalazła małego robaka, gdakała głośno „Ko Ko Ko” i wszystkie małe kurczęta biegły do niej, ponieważ rozumiały to jej gdakanie.\nTylko mały orzeł nie rozumiał nic z tego ich gdakania. Małe kurczęta wyśmiewały się z tego śmiesznego małego współtowarzysza, ale on nie rozumiał, o czym one szczebiotały, ponieważ mówił innym językiem.\nKurczęta grzebały w kupie gnoju, „Ko Ko Ko”, bo uwielbiały glizdy i robaki. Mały orzeł grzebał razem z nimi, ponieważ on nie znał nic innego, lecz tylko to, co widział, że robią kurczęta.\nJednak w nim było coś innego, on tego nie lubił.\nMały orzeł nie umiał zrozumieć dlaczego tak się działo i dlaczego to on musiał być tym brzydkim ptakiem; do tego tak bardzo odmiennym od całej reszty.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "La vecchia gallina si ruzzolava sempre nell'aia su un cumulo di concime. Ogni volta che lei trovava un verme, chiocciava forte. ”coccodé, coccodè, coccodé” e tutti i piccoli pulcini andavano da lei correndo, perché capivano il motivo del suo chiocciare.\nSolo la piccola aquila non capiva nulla di quei coccodé. I piccoli pulcini maltrattavano quello strano piccolo essere, ma esso non poteva capire perché stessero pigolando, perché lui parlava una lingua differente.\nI pulcini ruzzolavano nel mucchio di concime, coccodè, coccodè, coccodé. A loro piacevano tanto i vermi e gli insetti e così l’acquilotto si mise a ruzzolare con loro, perché non sapeva fare altro, se non quello che vedeva fare ai pulcini. Però, a differenza degli altri, a lui tutto questo non piaceva.\nNon riusciva a capire perché tutto andava in quel modo, e perché lui doveva essere quell’uccello brutto e così diverso dagli altri.",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Bătrâna cloşcă scormonea în grajd şi pe grămada de gunoi şi, de fiecare dată când găsea câte un viermişor, cotcodăcea foarte tare „clonc-clonc-clonc clonc” şi toţi puişorii veneau fuga la ea, fiindcă înţelegeau tot cloncănitul.\nNumai vulturaşul nu înţelegea nimic din cloncănit. Toţi puii îl ciocăneau pe acel ins ciudat, dar el nu putea înţelege de ce ciripeau ei, deoarece vorbea o limbă diferită.\nPuii scormoneau pe grămada de gunoi ,piu-piu-piu. Iubeau viermii şi gandacii, iar vulturaşul scormonea cu ei pentru ca nu ştia mai mult ,decât ce vedea pe pui făcând. Dar era ceva diferit în el, nu-i plăcea aceasta.\nEl doar nu înţelegea de ce totul se petrecea aşa, şi de ce era pasărea urâtă şi atât de diferită de ceilalţi. Astfel vulturaşul urma puii.",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory5.ad5051ff.jpg",
                "svg": "/assets/svgs/EagleBook05.1d174d8a.svg",
                "lang": {
                    "en": {
                        "text": "Meanwhile the mother eagle remembered well how many eggs she had laid, and that one egg was missing. She knew that her little eagle had to be somewhere, so she started out on the hunt for him.\nShe said, 'Somebody stole my egg. My baby eagle is somewhere, and I will go and find it.'\nSo she flapped her wings and circled over the mountaintops and down through the valleys and everywhere, to see where he might be.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Die Adlermutter erinnerte sich genau wieviele Eier sie gelegt hatte und dass ein Ei fehlte. Sie wußte auch, dass ihr kleiner Adler irgendwo sein musste und fing an, ihn zu suchen.\nSie sagte: “Jemand hat mein Ei gestohlen. Mein kleiner Adler ist irgendwo und ich werde gehen und ihn finden.“\nSo kreiste sie über Berge und hinunter in die Täler, überall hin wo er vielleicht sein könnte.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Il ne pouvait tout simplement pas comprendre pourquoi tout allait ainsi et pourquoi il devait être le vilain oiseau, si différent du reste d’entre eux.\nPendant ce temps, la maman aigle se rappelait très bien du nombre d’œufs qu’elle avait pondus, et cet œuf-là manquait. Elle savait que son petit aigle devait se trouver quelque part, ainsi elle commença à le chercher.\nElle dit, “Quelqu’un a volé mon oeuf. Mon bébé aigle est quelque part et je m’en vais le chercher.”\nElle battit donc des ailes et tournoya au-dessus des sommets des montagnes et au fond des vallées, partout où elle pensait pouvoir le trouver.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "W międzyczasie mama orlica pamiętała dobrze ile jajek złożyła, i że brakowało jej jednego jajka. Ona wiedziała, że gdzieś musi być jej mały orzeł, a więc rozpoczęła poszukiwania.\nOrlica powiedziała: „Ktoś ukradł moje jajko. Moje dziecko orzeł gdzieś tu jest i ja polecę i odnajdę go.”\nA więc orlica zamachała swoimi skrzydłami i krążyła ponad szczytami gór, w dół poprzez doliny, wszędzie, wypatrując go.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "Nello stesso tempo, la madre aquila, si ricordava esattamente quante uova aveva inizialmente deposto, e si accorse dell’uovo mancante. Essa sapeva che il suo piccolo aquilotto doveva essere da qualche parte, così iniziò a cercarlo.\nEssa disse: “Qualcuno ha rubato il mio uovo. Il mio aquilotto è da qualche parte ed io lo troverò.“\nCosì sbatté le sue ali e volteggiò sulle cime delle montagne e giù per le valli, dovunque, per vedere dove poteva esser finito.",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Între timp mama vultur şi-amintit câte ouă a depus, si un ou lipsea. Ea ştia că vulturaşul său trebuia să fie pe undeva, aşa că a început să-l caute.\nEa spunea: “Bebeluşul meu vultur este pe undeva şi eu voi merge şi îl voi găsi!“\nAşa ea a fâlfâit din aripile sale şi a început să se rotească peste vârfurile munților, jos in văi, prin văi şi peste tot, să vada unde el putea fi.",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory6.cf06248e.jpg",
                "svg": "/assets/svgs/EagleBook06.12a58fcc.svg",
                "lang": {
                    "en": {
                        "text": "One day the mother eagle flew over the farmer’s barnyard. She looked back and forth and down into the barn. There she found her little eagle.\nShe screamed, 'Look up little eagle, this way! You are my son!' He turned his little head and looked up. There was a creature with great and mighty wings, more powerful than all the chickens in the barnyard, and it cried, “You are mine!“\nShe circled over the barnyard again and shouted down, “Honey, you’re not a chicken. You’re mine. Come out of it!“\nOh, the little eagle understood this language. It sounded real.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Eines Tages flog die Adlermutter über den Hühnerhof. Sie schaute hin und her und hinab in den Hof, und dort fand sie ihren kleinen Adler.\nSie rief laut: “Schau herauf kleiner Adler – hierher. Du bist mein Sohn!“ Er drehte seinen kleinen Kopf und sah nach oben. Dort war eine Kreatur mit großen breiten Flügeln, mächtiger als alle Hühner im ganzen Hof und rief, “Du bist mein!“\nSie kreiste noch einmal über den Hof und rief hinab: “Liebling - du bist kein Küken. Du gehörst mir. Komm herauf!“\nOh, diese Sprache verstand der kleine Adler, das hörte sich echt an.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Un jour la maman aigle vola au-dessus de la basse-cour du fermier. Elle scruta et chercha dans la basse-cour. Là, elle trouva son petit aigle.\nElle s’écria, “Regarde en haut, petit aigle, par ici ! Tu es mon fils !” Il tourna sa petite tête et regarda vers le ciel. Il y avait là une créature avec de grandes ailes puissantes, plus puissantes que celles de tous les poulets de la basse-cour, et elle criait, „ Tu es à moi!”\nElle tournoya à nouveau au-dessus de la basse-cour et lui cria, „Chéri, tu n’es pas un poulet. Tu es à moi. Sors de là!”\nOh, le petit aigle comprit ce langage, cela semblait réel.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Pewnego dnia matka orlica przefrunęła nad podwórzem rolnika. Patrzyła tu i tam, na stodołę w dole. I tam znalazła swojego małego orła.\nOrlica zawołała: ”Popatrz w górę, mały orle, tutaj! Jesteś moim synem”. Mały orzeł przekręcił swoją małą główkę i popatrzył w górę. Tam było wspaniałe stworzenie z potężnymi skrzydłami, o wiele potężniejsze niż wszystkie kurczaki na całym podwórzu, które wołało: ”Jesteś mój!”\nOrlica jeszcze raz okrążyła podwórze i zawołała: „Kochanie, nie jesteś kurczakiem, Jesteś mój. Wyjdź stamtąd!”\nO, mały orzeł rozumiał ten język. On brzmiał znajomo.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "Un giorno la mamma aquila volò sopra l'aia dell'agricoltore. Guardava avanti ed indietro fin dentro il granaio . Lì trovo il suo aquilotto.\nE gridò: ”Guarda su, acquilotto, da questa parte! Tu sei mio figlio!” L’aquilotto girò la sua piccola testa e guardò verso su. Cera una creatura con ali grandi e imponenti, più potente di tutti i polli nell'aia, ed essa gridò:”Tu sei mio!”\nEssa volteggiò sopra l'aia nuovamente e gridò: ”Tesoro, tu non sei un pollo. Tu sei mio. Esci fuori di lì!”\nOh, l'aquilotto capiva questa lingua. Sembrava reale.",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Într-o zi mama vultur zbura deasupra ocolului. Ea s-a uitat în spate, în faţă şi în jos, în ocol. Acolo a găsit vulturaşul.\nA strigat, ”Ridică-ţi privirea, pe-aici. Tu eşti fiul meu!” El şi-a întors căpşorul şi s-a uitat sus. Acolo era o creatură cu aripi enorme si puternice, mai puternică decât toţi puii din ocol, şi ea striga, ”Tu eşti al meu!”\nEa s-a învârtit prin curtea găinilor din nou şi a strigat ”Dragă tu nu eşti un pui de găină. Eşti al meu. Ieşi afară de acolo!”\nOh vulturaşul a înţeles această limbă. Suna real.",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory7.6af2e7c3.jpg",
                "svg": "/assets/svgs/EagleBook07.e1209e9c.svg",
                "lang": {
                    "en": {
                        "text": "Do you know what happened? The little eagle asked his mommy hen, “Can anyone get up there?“\n“Cluck cluck cluck. No, never! And don't ever tell my chickens anything like that.“",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Weißt du was geschah? Der kleine Adler fragte seine Hühnermama: “Kann jemand dort hinaufkommen?“\n“Gluck gluck gluck – nein, nie! Fang ja nicht an, so etwas meinen Kücken zu erzählen.“",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "ISavez-vous ce qui arriva alors ? Le petit aigle demanda à sa maman-poule, “Quelqu’un peut-il monter là-haut?”\n“Cot, cot, cot. Non, jamais ! Et ne raconte jamais une chose pareille à mes petits poulets.”",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Czy wiesz co się stało? Ten mały orzeł zapytał swojej mamy kury: ”Czy ktoś może się dostać tam do góry?”\n”Ko Ko Ko. Nie, nigdy! I nigdy nie próbuj mówić moim kurczakom takich rzeczy!” odpowiedziała kura.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "Sai cosa è successo? La piccola aquila domandò alla sua madre gallina: ”Si può forse arrivare così in alto?”\n”Coccodè, coccodè, coccodè. No, impossibile! E non dire mai ai miei pulcini una cosa del genere.”",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Ştiţi ce s-a întâmplat? Vulturaşul şi-a întrebat cloşca, ”Poate cineva ajunge acolo sus?”\nClon-clon- clonc. Nu, nu niciodată! Nu începe să spui la puii mei astfel de lucruri.",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory8.f7822231.jpg",
                "svg": "/assets/svgs/EagleBook08.4932a0a1.svg",
                "lang": {
                    "en": {
                        "text": "Again the mother eagle circled over the barnyard and cried, “You’re not a chicken, you don’t belong there. You’re an eagle and you belong to me. Raise up!“\nThe little eagle cried back, “But mother, how do I get up there? They tell me I have to stay down here.“\n“Just run, honey. Flap your wings, and I will catch you. You’re an eagle!“",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Die Adlermutter flog wieder über den Hof und rief: “Du bist kein Küken, du gehörst nicht dorthin, du bist ein Adler und gehörst mir. Komm herauf!“\nEr rief zurück: “Aber Mama, wie kann ich da hinauf kommen? Sie sagen mir, daß ich hier unten bleiben muss.“\n“Spring einfach los Liebling und schlage mit den Flügeln – ich werde dich auffangen. Du bist doch ein Adler!“",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Une fois encore la maman aigle tournoya au-dessus de la basse-cour et cria, “Tu n’es pas un poulet, tu ne leur appartiens pas. Tu es un aigle et tu m’appartiens. Monte ici!“\nLe petit aigle répondit „ Mais maman, comment puis-je monter là-haut ? Ils me disent que je dois rester ici.”\n“Cours simplement, chéri, bats des ailes et je t’attraperai. Tu es un aigle !“",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Matka orlica jeszcze raz okrążyła podwórze, wołając ”Nie jesteś kurczakiem, nie należysz do nich. Jesteś orłem i należysz do mnie. Unieś się w powietrze!”\nMały orzeł zawołał w odpowiedzi: ”Ale mamo, jak ja się tam dostanę? Oni mi mówią, że ja muszę zostać tu na dole.”\n„Po prostu biegnij kochanie. Zamachaj swoimi skrzydełkami, a ja cię złapię. Jesteś orłem.”",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "Di nuovo la madre aquila volteggiò sopra l'aia e gridò: ”Tu non sei un pollo, non fai parte di quel posto. Tu sei un'aquila e mi appartieni. Vola via da lì!”\nL'aquilotto le rispose: ”Ma mamma, come arrivo fin lassù? Loro mi dicono che devo stare quaggiù.”\n”Tesoro, corri semplicemente. Sbatti le ali, ed io ti afferrerò. Tu sei un'aquila!”",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Încă o dată mama vultur s-a învârtit peste curtea găinilor şi a strigat, „Tu nu eşti pui de găina, tu nu aparţi acolo. Eşti un vultur şi-mi aparţi. Ridică-te!”\nEl a strigat înapoi, „Dar mamă, cum pot ajunge acolo sus? Mi s-a spus că trebuie să stau aici jos.”\n”Doar aleargă, dragă. Dă din aripi şi eu te voi prinde. Eşti un vultur!”",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory9.d782af9f.jpg",
                "svg": "/assets/svgs/EagleBook09.8a534cb7.svg",
                "lang": {
                    "en": {
                        "text": "So the little eagle took a jump. He wildly flapped his wings and hit them right on the barnyard post.\nThen he fell back into the middle of another barnyard. From one chicken yard into the next.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Der kleine Adler machte einen großen Sprung, schlug wild mit seinen Flügeln und flog genau an den dicken Pfosten des Scheunenhofs.\nDann fiel er zurück - mitten hinein in einen anderen Hof. Von einem Hühnerhof in den Nächsten.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Ainsi, le petit aigle sauta. Il battit fortement des ailes et les heurta au poteau de la basse-cour.\nIl retomba alors juste au milieu d’une autre basse-cour. D’un poulailler à un autre.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Więc mały orzeł podskoczył. Dziko zatrzepotał skrzydełkami i uderzył prosto w słup na podwórku.\nA potem spadł na sąsiednie podwórze. Z jednego kurnika do drugiego.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "Così l’acquilottoa fece un salto. Sbattè selvaggiamente e li urtò contro il palo dell'aia.\nCosicché cadde nel mezzo di un'altra aia. Da un pollaio all’altro.",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Vulturaşul a sărit puţin. El a bătut sălbatic din aripi şi le-a lovit de stâlpul gardului.\nApoi a căzut, chiar în mijlocul altei curţi. Dintr-o curte de găini în alta.",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory10.fab22d00.jpg",
                "svg": "/assets/svgs/EagleBook10.35f01389.svg",
                "lang": {
                    "en": {
                        "text": "When the mother eagle saw it, she swooped down, flew over the barnyard and screamed at the top of her voice:\n'Jump higher, little eagle. If you can’t jump higher than that, I can’t catch you. You have to jump higher than the fences.'\nThe little eagle looked around and saw how the chickens watched him, but then he heard her cry out again:\n'I know you can do it. Just try it again. Jump to your feet! Jump, and don’t worry, you’re an eagle! I’ll be right there to catch you.'\n'I will make it, Mommy. I believe it', he cried back.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Als die Adlermutter das sah, stürzte sie herab und schrie so laut sie konnte: “Spring höher kleiner Adler! Wenn du nicht höher springen kannst, dann kann ich dich nicht fassen. Du musst höher springen wie diese Zäune.“\nDer kleine Adler schaute herum und sah wie all die Hühner auf ihn schauten. Dann hörte er wieder ihren Schrei:\n“Ich weiss, dass du es kannst. Komm versuche es noch einmal! Spring und fürchte dich nicht, du bist ein Adler! Ich werde da sein und dich auffangen!“\n“Ich werde es schaffen, Mama, ich glaube es“ rief er zurück.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Lorsque la maman aigle le vit, elle plongea, vola au-dessus de la basse-cour et cria de toutes ses forces:\n“Saute plus haut petit aigle. Si tu ne peux pas sauter plus haut, je ne peux pas t’attraper. Tu dois sauter plus haut que les barrières.”\nLe petit aigle regarda autour de lui et remarqua que les poulets l’observaient, mais il l’entendit à nouveau crier:\n“Je sais que tu peux y arriver. Essaie encore ! Saute sur tes pattes ! Saute et ne t’inquiète pas, tu es un aigle ! Je serai là pour t’attraper.“\n“Je vais y arriver, maman. Je le crois.“ cria-t-il à son tour.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Kiedy matka orlica to zobaczyła, zanurkowała w dół, przefrunęła nad podwórzem i krzyczała najgłośniej jak mogła:\n”Wznieś się wyżej mały orle. Jeśli nie podskoczysz wyżej, nie będę mogła cię złapać. Musisz wznieść się wyżej niż te płoty.”\nMały orzeł popatrzył dookoła i zobaczył, że wszystkie kurczaki mu się przyglądały i jeszcze raz usłyszał wołanie:\n”Wiem, że potrafisz. Spróbuj jeszcze raz. Skocz na nogi! Podskocz i nie bój się, jesteś przecież orłem! Ja cię złapię.”\n”Uda mi się mamo! Ja w to wierzę!”, odkrzyknął orzeł.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "Quando la madre aquila lo vide, scese in picchiata, volò sopra il pollaio e gridò a gran voce:\n”Salta più in alto, acquilotto, se non lo fai non posso afferrarti. Devi saltare più in alto dello steccato.”\nL'aquilotto si guardò intorno e vide come i polli lo guardavano, allora la udì gridare nuovamente:\n”So che puoi farcela, basta che provi dinuovo. Salta sui tuoi piedi! Salta e non preoccuparti, sei un'aquila! Io sarò proprio lì per afferrarti.”\n”Ce la farò, Mamma. Ci credo,” rispose.",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Mama vultur a dat târcoale zburând peste curtea găinilor şi a strigat cât a putut de tare:\n”Sari mai sus vulturaşule. Dacă nu poţi sări mai sus nu te pot prinde. Tu trebuie să sari mai sus decât aceste garduri.”\nMicuțul vultur s-a uitat în jur şi a văzut cum puii se uitau la el, dar a auzit-o pe ea strigând din nou:\n”Stiu că o poți face,doar vino, incearcă din nou! Sari în picioare. Sari şi nu te îngrijora, eşti un vultur! Voi fi chiar acolo să te prind.”",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory11.c69b1cab.jpg",
                "svg": "/assets/svgs/EagleBook11.df5a889d.svg",
                "lang": {
                    "en": {
                        "text": "Then he flapped his wings again and jumped with all that was in him.\nThe eagle caught him, and together they went into the skies. Oh how good it was!",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Dann schlug er mit seinen Flügeln und sprang mit allem was in ihm war.\nDer Adler griff ihn – und hinauf ging es in die Lüfte. Oh wie gut war das!",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Il battit alors des ailes et sauta de toutes ses forces.\nL’aigle l’attrapa et, ensemble, ils s’envolèrent dans les cieux.\nOh, comme c’était merveilleux !",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Po czym machnął skrzydłami i podskoczył dając z siebie wszystko.\nOrlica złapała go i razem poszybowali w przestworza. O, to było wspaniałe uczucie!",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "Allora di nuovo sbatté le ali e saltò con tutte le sue forze.\nL'aquila l'afferrò, ed insieme volarono nei cieli. Oh, com'era bello!",
                        "audio": ""
                    },
                    "ro": {
                        "text": "”Voi reuşi mami, eu o cred”, a strigat înapoi el, şi a sărit cu toată puterea.\nVulturul l-a prins şi a plecat cu el spre cer. Oh ce bine era!",
                        "audio": ""
                    }
                }
            },
            {
                "pageIllustration": "/assets/img/colorbook/EagleStory12.83cf4f0d.jpg",
                "svg": "/assets/svgs/EagleBook12.20f47f54.svg",
                "lang": {
                    "en": {
                        "text": "Then the little eagle took his first solo flight. He set his wings in the wind and glided higher and higher. He soared over mountains, over many waters and beautiful meadows.\nHere was his true home, everything was beautiful.\nHe was back in the heavens where he came from, alive and finally free. For he was an eagle, and he had always been one.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "de": {
                        "text": "Dann machte der junge Adler seinen ersten Alleinflug. Er setzte die Flügel in den Wind, höher und höher hinauf über Berge und Seen und weite grüne Täler.\nHier war seine wirkliche Heimat. Und alles war wunderbar. Er war zurück in den Lüften von wo er kam, lebendig und endlich frei.\nDenn er war ein Adler und er ist immer einer gewesen.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "fr": {
                        "text": "Puis, le petit aigle prit son envol pour la première fois seul. Il déploya ses ailes dans le vent, et monta de plus en plus haut. Il survola les montagnes, les rivières et de magnifiques paysages.\nC’était là son vrai foyer, tout était si magnifique.\nIl était de retour dans les cieux, là d’où il venait, en vie et enfin libre. Car il était un aigle et l’avait toujours été.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "pl": {
                        "text": "Po chwili mały orzeł odbył swój pierwszy samodzielny lot. Rozpostarł skrzydła na wietrze i szybował coraz wyżej. Leciał ponad górami, nad wieloma wodami i pięknymi łąkami.\nTu był jego prawdziwy dom, wszystko było piękne. On był z powrotem w niebie, skąd pochodził; żywy i nareszcie wolny. Ponieważ on był orłem i był nim zawsze.",
                        "audio": "/assets/audio/flower.mp3"
                    },
                    "it": {
                        "text": "L'aquilotto fece il suo primo volo da solo. Spiegò le sue ali e volava sempre più in alto. Si elevava sopra montagne, passava sopra fiumi e ruscelli meravigliose praterie.\nQuesta era la sua vera casa, ogni cosa era stupenda. Esso era di nuovo nei cieli, da dove era venuto ed era vivo e finalmente libero. Era un'aquila, lo era sempre stato.",
                        "audio": ""
                    },
                    "ro": {
                        "text": "Apoi vulturaşul şi-a făcut primul zbor singur. Şi-a aşezat aripile în vânt, mai sus şi mai sus în libertatea cerească, s-a avatat peste munți, peste multe ape şi lunci frumoase.\nAcolo era adevărata lui casa,totul era aşa de frumos. Era înapoi în ceruri de unde a venit,viu şi in sfarşit liber,pentru că era un vultur şi intotdeauna a fost un vultur.",
                        "audio": ""
                    }
                }
            }
        ]
    },
    "stories": [
        {
            "id": 0,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/0.63820bef.jpg",
                    "pdf": "/assets/pdf/en/0.0d937176.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/0.bf28e789"
                },
                "de": {
                    "cover": "/assets/img/stories/en/0.63820bef.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/0.63820bef.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/0.63820bef.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/0.63820bef.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/0.63820bef.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 1,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/1.c878a29b.jpg",
                    "pdf": "/assets/pdf/en/1.1c3a2066.pdf",
                    "pages": 10,
                    "pageDir": "/assets/img/stories/pages/en/1.8b56446d"
                },
                "de": {
                    "cover": "/assets/img/stories/en/1.c878a29b.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/1.c878a29b.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/1.c878a29b.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/1.c878a29b.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/1.c878a29b.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 2,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/2.05981763.jpg",
                    "pdf": "/assets/pdf/en/2.eefda3fa.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/2.45b6f0ba"
                },
                "de": {
                    "cover": "/assets/img/stories/en/2.05981763.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/2.05981763.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/2.05981763.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/2.05981763.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/2.05981763.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 3,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/3.e41be5c8.jpg",
                    "pdf": "/assets/pdf/en/3.76d46d1e.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/3.93646e88"
                },
                "de": {
                    "cover": "/assets/img/stories/en/3.e41be5c8.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/3.e41be5c8.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/3.e41be5c8.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/3.e41be5c8.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/3.e41be5c8.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 4,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/4.f911e1b7.jpg",
                    "pdf": "/assets/pdf/en/4.7e0f8e29.pdf",
                    "pages": 6,
                    "pageDir": "/assets/img/stories/pages/en/4.dc17e49a"
                },
                "de": {
                    "cover": "/assets/img/stories/en/4.f911e1b7.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/4.f911e1b7.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/4.f911e1b7.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/4.f911e1b7.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/4.f911e1b7.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 5,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/5.0cd3f8b3.jpg",
                    "pdf": "/assets/pdf/en/5.6ac5e08c.pdf",
                    "pages": 8,
                    "pageDir": "/assets/img/stories/pages/en/5.99d617c2"
                },
                "de": {
                    "cover": "/assets/img/stories/en/5.0cd3f8b3.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/5.0cd3f8b3.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/5.0cd3f8b3.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/5.0cd3f8b3.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/5.0cd3f8b3.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 6,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/6.3b9a71aa.jpg",
                    "pdf": "/assets/pdf/en/6.8fce2177.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/6.5aed9e21"
                },
                "de": {
                    "cover": "/assets/img/stories/en/6.3b9a71aa.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/6.3b9a71aa.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/6.3b9a71aa.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/6.3b9a71aa.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/6.3b9a71aa.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 7,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/7.b09fe583.jpg",
                    "pdf": "/assets/pdf/en/7.3588b9c1.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/7.2c8fdcd7"
                },
                "de": {
                    "cover": "/assets/img/stories/en/7.b09fe583.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/7.b09fe583.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/7.b09fe583.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/7.b09fe583.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/7.b09fe583.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 8,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/8.b053428f.jpg",
                    "pdf": "/assets/pdf/en/8.07aa1181.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/8.bacb1e8f"
                },
                "de": {
                    "cover": "/assets/img/stories/en/8.b053428f.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/8.b053428f.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/8.b053428f.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/8.b053428f.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/8.b053428f.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 9,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/9.03b3020f.jpg",
                    "pdf": "/assets/pdf/en/9.8b33ccea.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/9.94fb6f8d"
                },
                "de": {
                    "cover": "/assets/img/stories/en/9.03b3020f.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/9.03b3020f.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/9.03b3020f.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/9.03b3020f.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/9.03b3020f.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 10,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/10.614bd4f5.jpg",
                    "pdf": "/assets/pdf/en/10.c95fded9.pdf",
                    "pages": 8,
                    "pageDir": "/assets/img/stories/pages/en/10.873af6da"
                },
                "de": {
                    "cover": "/assets/img/stories/en/10.614bd4f5.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/10.614bd4f5.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/10.614bd4f5.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/10.614bd4f5.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/10.614bd4f5.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 11,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/11.cc930abb.jpg",
                    "pdf": "/assets/pdf/en/11.ee41593a.pdf",
                    "pages": 6,
                    "pageDir": "/assets/img/stories/pages/en/11.9ef819da"
                },
                "de": {
                    "cover": "/assets/img/stories/en/11.cc930abb.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/11.cc930abb.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/11.cc930abb.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/11.cc930abb.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/11.cc930abb.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 12,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/12.94344c37.jpg",
                    "pdf": "/assets/pdf/en/12.fc24c404.pdf",
                    "pages": 6,
                    "pageDir": "/assets/img/stories/pages/en/12.f4797d14"
                },
                "de": {
                    "cover": "/assets/img/stories/en/12.94344c37.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/12.94344c37.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/12.94344c37.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/12.94344c37.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/12.94344c37.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 13,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/13.32a19901.jpg",
                    "pdf": "/assets/pdf/en/13.b823dc27.pdf",
                    "pages": 8,
                    "pageDir": "/assets/img/stories/pages/en/13.6fef82a9"
                },
                "de": {
                    "cover": "/assets/img/stories/en/13.32a19901.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/13.32a19901.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/13.32a19901.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/13.32a19901.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/13.32a19901.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 14,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/14.974a29f4.jpg",
                    "pdf": "/assets/pdf/en/14.141d45ce.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/14.18d99c13"
                },
                "de": {
                    "cover": "/assets/img/stories/en/14.974a29f4.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/14.974a29f4.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/14.974a29f4.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/14.974a29f4.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/14.974a29f4.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 15,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/15.384fb3d4.jpg",
                    "pdf": "/assets/pdf/en/15.5ed45550.pdf",
                    "pages": 4,
                    "pageDir": "/assets/img/stories/pages/en/15.59245ba3"
                },
                "de": {
                    "cover": "/assets/img/stories/en/15.384fb3d4.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/15.384fb3d4.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/15.384fb3d4.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/15.384fb3d4.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/15.384fb3d4.jpg",
                    "pdf": ""
                }
            }
        },
        {
            "id": 16,
            "lang": {
                "en": {
                    "cover": "/assets/img/stories/en/16.83a9f259.jpg",
                    "pdf": "/assets/pdf/en/16.018c617b.pdf",
                    "pages": 6,
                    "pageDir": "/assets/img/stories/pages/en/16.b1ed6236"
                },
                "de": {
                    "cover": "/assets/img/stories/en/16.83a9f259.jpg",
                    "pdf": ""
                },
                "fr": {
                    "cover": "/assets/img/stories/en/16.83a9f259.jpg",
                    "pdf": ""
                },
                "pl": {
                    "cover": "/assets/img/stories/en/16.83a9f259.jpg",
                    "pdf": ""
                },
                "it": {
                    "cover": "/assets/img/stories/en/16.83a9f259.jpg",
                    "pdf": ""
                },
                "ro": {
                    "cover": "/assets/img/stories/en/16.83a9f259.jpg",
                    "pdf": ""
                }
            }
        }
    ]
}